import React, { useRef, useEffect, useContext, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Icon } from "@iconify/react";
import { store } from "../Store";

import { useAdvancedSearch } from "../../hooks/advanced-search/use-advanced-search";
import { useAdvancedSearchContentData } from "../../hooks/advanced-search/use-advanced-search-content-data";
import useObtenerSubsecciones from "../../js/translations/useObtenerSubsecciones";
import { useUserBooks } from "../../hooks/useUserBooks";
import useIsAdvancedSearchMobile from "./hooks/useIsAdvancedSearchMobile";

import { SearchInput } from "./search-input";
import { AdvancedSearchItems } from "./item-cards";

import _ from "lodash";
import { FocusScope } from "react-aria";
import { useId } from "../../hooks/use-id";
import { LanguageSwitcher } from "../language/LanguageSwitcher";
import { AdvancedSearchMobile } from "./components/AdvancedSearchMobile";
import { AdvancedSearchDesktop } from "./components/AdvancedSearchDesktop";

/**
 * Componente principal del menú de búsqueda avanzada,
 * se encarga de renderizar el Header, Footer, y el contenido donde se muestran todos los items (generos, materias, niveles de lecturas, tags, entre otros.)
 * @returns {React.Component}
 */
export const AdvancedSearch = () => {
    const { textosSubSecciones: textos } = useObtenerSubsecciones('busqueda_avanzada');
    const advancedSearch = useAdvancedSearch();
    const visible = advancedSearch?.state?.visible;
    const data = useAdvancedSearchContentData();
    const history = useHistory();
    const ref = useRef(null);
    const globalState = useContext(store);
    const triggerButton = globalState?.state?.advancedSearch?.triggerButton;
    const userBooksData = useUserBooks();
    const isMobile = useIsAdvancedSearchMobile();
    const titleId = useId("advanced-search-title");

    const hide = () => {
        advancedSearch.setVisible(false);
    }
    useEffect(() => {
        if (visible) {
            document.getElementsByTagName('html')[0].style.overflowY = "hidden";
        } else {
            document.getElementsByTagName('html')[0].style.overflowY = "auto";
        }
    }, [visible])

    const handleOutsideClick = (event) => {
        const path = event.composedPath ? event.composedPath() : [];
        const clickInsideDialog = path.includes(ref.current) || ref.current?.contains(event.target);

        if (triggerButton?.current?.contains(event.target) || clickInsideDialog) {
            return;
        }
        advancedSearch.setVisible(false);
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [triggerButton]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                advancedSearch.setVisible(false);
            }
        };

        if (visible) {
            document.addEventListener("keydown", handleKeyDown);
        }

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [visible]);

    return (
        <div
            ref={ref}
            onClick={(e) => e.target === e.currentTarget && hide()}
            className={`advanced-search ${visible ? 'visible' : 'hidden'}`}
            role="dialog"
            aria-modal="true"
            aria-labelledby={visible? titleId : undefined}
        >
            {advancedSearch?.state?.loadingContent && userBooksData.loading ?
                <div className="w-100 h-100 d-flex justify-content-center align-items-center">
                    <Icon icon="icomoon-free:spinner9" width={60} className={'spinner-rotation secondary-inverse--color'} />
                </div>
                :
                visible && (
                    <FocusScope contain restoreFocus autoFocus>
                        <p id={titleId} className="sr-only">{textos?.a11y.title || "Búsqueda avanzada"}</p>

                        {isMobile ? (
                            <AdvancedSearchMobile
                                textos={textos}
                                data={data}
                                onClose={hide}
                            /> 
                        ) : (
                            <AdvancedSearchDesktop
                                textos={textos}
                                data={data}
                                onClose={hide}
                            />
                        )}
                    </FocusScope>
                )
            }
        </div >)
}


